export default __webpack_public_path__ + "static/media/member12.b435bd56.jpg";